import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { usePortal } from '../contexts/PortalContext';
export function Toast() {
  const {
    toast
  } = usePortal();
  return <div className="pointer-events-none fixed bottom-5 left-5 z-40" aria-live="polite" data-id="element-449" data-mp="a82gr59eviv2">
      <AnimatePresence data-id="element-450" data-mp="f6wx80jwovc0">
        {toast && <motion.p key={toast} initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="label m-0 border border-ink bg-ink px-4 py-3 text-paper" data-id="element-451" data-mp="f7yiexumyy7g">
            {toast}
          </motion.p>}
      </AnimatePresence>
    </div>;
}